import { ModelError } from './ModelError';

export const NOT_FOUND_ERROR_NAME = 'NOT_FOUND_ERROR';

export class NotFoundError extends ModelError {
  public readonly name: string = NOT_FOUND_ERROR_NAME;
}
